<template>
  <div class="container">
    <DefaultTemplate title="" subtitle="" :steps="false">
      <PrivacyPolicyTH v-if="$i18n.locale === 'th'" :rule="rule" />
      <PrivacyPolicyEN v-else :rule="rule" />
    </DefaultTemplate>
  </div>
</template>
<script>
import DefaultTemplate from "@/template/DefaultTemplate.vue";
import PrivacyPolicyEN from "@/components/privacyPolicy/PrivacyPolicyEN";
import PrivacyPolicyTH from "@/components/privacyPolicy/PrivacyPolicyTH";

export default {
  components: {
    DefaultTemplate,
    PrivacyPolicyEN,
    PrivacyPolicyTH,
  },
  data() {
    return {
      rule: this.$route.params.rule,
    };
  },
  created() {
    this.$store.commit("setSpaPage", null);
  },
};
</script>
